import React, { useEffect, useState } from "react";
import {
  useDeleteRoleMutation,
  useGetRolesQuery,
} from "../../api/admin/rolesApi";
import CoreTable from "../../../app/core/components/CoreTable/CoreTable";
import CoreButtonHoverIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import DeleteIcon from "@mui/icons-material/Delete";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { t } from "i18next";
import { formatItalianDate } from "../../../utils/functions/date-utils";
import CoreModal from "../../../app/core/components/CoreModal/CoreModal";
import CoreDialog from "../../../app/core/components/CoreDialog/CoreDialog";
import { toast } from "react-toastify";
import DetailRuoli from "./DetailRuoli";
import CoreViewLists from "../../../app/core/components/CoreViewLists/CoreViewLists";

const GestioneRuoli = () => {
  const [rows, setRows] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [role, setRole] = useState();

  const { data, isLoading, refetch } = useGetRolesQuery();
  const [deleteRole] = useDeleteRoleMutation();

  const columns = {
    name: t("Name"),
    enabled: t("Activated"),
    createdAt: t("Created"),
    adminsCount: t("Admin"),
    capabilities: t("Capability"),
  };

  useEffect(() => {
    if (data && data.Data) {
      const rolesData = data.Data.map((el) => ({
        id: el.id,
        name: el.name,
        enabled: el.enabled ? t("Yes") : t("No"),
        createdAt: formatItalianDate(el.createdAt),
        adminsCount: el.adminsCount,
        capabilities: (
          <CoreViewLists
            value={el.capabilities}
            text={t("Capability")}
            param={
              el.capabilities.length > 0
                ? Object?.keys(el.capabilities[0])[1]
                : 0
            }
          />
        ),
      }));

      setRows(rolesData);
    }
  }, [data]);

  const handleClose = () => {
    setRole(null);
    refetch();
    setOpenModal(false);
  };
  const handleOpen = () => setOpenModal(true);

  const handleEditOpen = (el) => {
    setRole(el.id);
    setOpenModal(true);
  };
  const handleDeleteRole = (el) => {
    setRole(el);
    setOpenDialog(true);
  };
  const handleCloseDelete = () => setOpenDialog(false);

  const handleConfermDialog = () => {
    deleteRole(role.id).then((res) => {
      if (res.data && res.data.Result !== 1) {
        toast.error(res.data.Exception || t("NotDeleteRole"));
        return;
      }
      toast.success(t("DeleteRole"));
      handleCloseDelete();
    });
  };

  const actions = [
    {
      icon: <EditRoundedIcon />,
      onClick: handleEditOpen,
      tooltip: t("Edit"),
    },
    {
      icon: <DeleteIcon className={"fill-rose-600"} />,
      onClick: handleDeleteRole,
      tooltip: t("Delete"),
    },
  ];

  return (
    <div>
      <div className="w-full">
        <div className="flex flex-row items-center space-x-4">
          <h2>{t("RolesPermitted")}</h2>
        </div>
        <div className="flex pb-4 space-x-4 items-center">
          <div>
            <CoreButtonHoverIcon
              className="text-blue-500 m-1 flex flex-row space-x-2 border"
              testo={t("Refresh")}
              icon={<RefreshRoundedIcon className={`fill-blue-500`} />}
              onClick={refetch}
            />
            <CoreButtonHoverIcon
              className="text-blue-500 m-1"
              icon={<AddBoxRoundedIcon className={`fill-blue-700`} />}
              testo={`${t("Role")}`}
              onClick={handleOpen}
            />
          </div>
        </div>
      </div>
      <CoreTable
        rows={rows}
        columns={columns}
        button
        actions={actions}
        isLoading={isLoading}
      />
      <CoreDialog
        open={openDialog}
        title={`Elimina Ruolo`}
        content={`Sei sicuro di eliminare ${role?.name} ?`}
        negativeButton={t("No")}
        positiveButton={t("Yes")}
        handlePositive={handleConfermDialog}
        closeDialog={handleCloseDelete}
      />

      <CoreModal
        width={"80%"}
        height={"70%"}
        state={openModal}
        onClose={handleClose}
        component={
          <DetailRuoli
            roleId={role}
            onClose={handleClose}
            onRefetch={refetch}
          />
        }
      />
    </div>
  );
};

export default GestioneRuoli;
